import React from "react"
import Link from "gatsby-link";
import {Container} from "react-responsive-grid";
import get from "lodash/get"
import Helmet from "react-helmet"
import Footer from '../../layouts/Footer';
import Button from '../../components/Button';
import Feature from './Feature';
import MailIcon from './mail.svgc';
import NetworkIcon from './network.svgc';
import SlackIcon from './slack.svgc';
import StopIcon from './stop.svgc';
import WebpackIcon from './webpack.svgc';
import GearsIcon from './gears.svgc';
import GithubIcon from './github.svgc';
import PullRequestsScreenshot from './pullrequests.png';
import ConsoleScreenshot from './console.png';
import DashboardScreenshot from './dashboard.png';
import Header from '../../layouts/Header';
import Logo from '../../logo.png';
import './index.css';
import {gaEvent} from '../../utils/ga';
import {rhythm} from "../../utils/typography";
import Arrow from "../../components/Arrow";
import SignupAndPlansSlide from "../../components/SignupAndPlansSlide";
import HeroSlide from "../../components/HeroSlide";
import CodeSampleTabs from "../../components/CodeSampleTabs";


class IndexPage extends React.Component {


  render() {
    return (
      <div className="IndexPage">

        <Helmet title="BundleCop Is Keeping Track of Your App's Size." />

        <HeroSlide
          hideLogo={true}
          bold={true}
          title={<span>Hi, I am the <nobr><img src={Logo} />.</nobr></span>}
          subtitle="I’ll tell you when your app becomes too large."
        />

        <div style={{borderBottom: '1px solid #eaeaea'}}><Container
          style={{
            maxWidth: rhythm(35),
            padding: `${rhythm(1.5)} 0`,
            paddingTop: 0,
          }}
          className="IndexPage-UseDiagram"
        >
            <CodeSampleTabs
              tabs={[
                {id: 'cli', code: this.props.data.cli.html, label: 'CLI'},
                {id: 'webpack', code: this.props.data.webpack.html, label: 'Webpack'}
              ]}
              initial="cli"
            />

            <div style={{
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'center'
            }} className="IndexPage-UseDiagram-Arrows">
              <Arrow
                style={{width: '300px', height: '100px'}}
                length={160}
                angle={220}
              />
              <Arrow
                style={{width: '300px', height: '100px'}}
                length={180}
                angle={180}
              />
              <Arrow
                style={{width: '300px', height: '100px'}}
                length={200}
                angle={140}
              />
            </div>

            <div style={{
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'space-around'
            }} className="IndexPage-UseDiagram-Examples">
              <div>
                <h2>Check pull requests</h2>
                <p>
                  BundleCop updates pull requests with size
                  information.
                </p>
                <img src={PullRequestsScreenshot} />
              </div>
              <div>
                <h2>Keep track</h2>
                <p>Which commits are responsible for a size increase?</p>
                <img src={DashboardScreenshot} />
              </div>
              <div>
                <h2>Fail your tests</h2>
                <p>
                  If your chosen limits or thresholds are exceeded,
                  do not allow a build to complete.
                </p>
                <img src={ConsoleScreenshot} />
              </div>
            </div>
        </Container></div>

        <Container
          style={{
            maxWidth: rhythm(35),
            padding: `${rhythm(1.5)} 0`,
            paddingTop: 0
          }}
        >
          <div className="IndexPage-Features">
            <Feature Icon={StopIcon}>
              <strong>Keep your file sizes down.</strong> {" "}
              Performance is a feature. Small file sizes are key to webapp performance, especially
              on mobile. BundleCop works by helping you report file sizes to our analyzer.
            </Feature>

            <Feature Icon={WebpackIcon}>
              <strong>webpack Plugin.</strong> Easily send data from any webpack-based project.
              {" "} <Link to="/docs/webpack">Read more.</Link>
            </Feature>

            <Feature Icon={GearsIcon}>
              <strong>Use with any tech or stack.</strong> Using our CLI, you can monitor the size of your .exe, .ipa, image files or anything else.
              {" "} <Link to="/docs/cli">Read more.</Link>
            </Feature>

            <Feature Icon={NetworkIcon}>
              <strong>We support your CI.</strong> We get data like branch name or parent commit from the CI and repo, so we know what to compare to.
              {" "} <Link to="/docs/tools">See supported tools.</Link>
            </Feature>

            <Feature Icon={MailIcon} comingSoon={true}>
              <strong>Receive notifications</strong> when file sizes exceed limits.
            </Feature>

            <Feature Icon={SlackIcon} comingSoon={true}>
              <strong>Send to Slack.</strong> We'll send updates to your team channels.
            </Feature>

            <Feature Icon={GithubIcon} comingSoon={true}>
              <strong>Integrates with Github.</strong> Can post status updates to pull requests.
            </Feature>

            <Feature Icon={WebpackIcon} comingSoon={true}>
              <strong>Browse webpack bundles.</strong> Look inside your bundles to know why they are big. Any stat is ready to browse.
            </Feature>
          </div>
        </Container>

        <SignupAndPlansSlide
          prompt="Fight dependency-creep, make your app fast"
        />

        <Footer />
      </div>
    )
  }

  showMailingListPopUp = () => {
    this.refs.mailchimp.open();
  };
}

IndexPage.propTypes = {
  route: React.PropTypes.object,
}

export default IndexPage;


export const pageQuery = graphql`
  query IndexPageQuery {
    webpack: markdownRemark(frontmatter: { snippet: { eq: "webpack" } }) {
      html
    }
    cli: markdownRemark(frontmatter: { snippet: { eq: "cli" } }) {
      html
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/index/index.js